
export default class {

    static render(station,services)
    {
        return `

        <div class="infoWindow">
            <h2 class="name"> ${station['NombreEstacion']} </h2>

            <h2> Dirección </h2>
            <p> ${station['Direccion']} </p>

            <h2> Fono </h2>
            <p> ${station['Telefono']} </p>

            <h2> GBL </h2>
            <p> ${station['GBL']} </p>

            <h2> Servicios </h2>

            <div class="container-services"> 
                ${services} 
            </div>

        </div>
    `;
    }
}
